import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Form } from 'react-bootstrap';
import '../assets/stylesheet/multiSelectInputType.css';
import { ShowToastUtil } from './showToastUtil';

const MultiSelectDropdown = ({options, handleMultiSelect, selectedItems, handleMultiSelectClear, lable}) => {
const [isOpen, setIsOpen] = useState(false);

const selectedItemsStr = selectedItems ? String(selectedItems) : '';
const selectedItemsArray = selectedItemsStr.split(',').filter(item => item !== '');
const uniqueItemsArray = [...new Set(selectedItemsArray)];
// useEffect(()=>{
//   if(uniqueItemsArray.length > 1)
//   {
//     ShowToastUtil("No data available for selected range", "warning");
//     return;
//   }
// }, [])
const placeholder = uniqueItemsArray.length === 1 
    ? `1 ${lable} is selected` 
    : uniqueItemsArray.length 
    ? `Multiple ${lable}s selected` 
    : `Select ${lable}`;

    const clearProjectFilter = () => {
    handleMultiSelectClear();
  };
  const onProjectSelect = (value, checked) => {
    handleMultiSelect(value, checked);
  };
  
  return (
    <div className="d-flex align-items-center">
      <Dropdown
        className="multiSelectTest"
        show={isOpen}
        onToggle={() => setIsOpen(!isOpen)}
      >
        {" "}
        <Dropdown.Toggle
          as={Button}
          variant="outline-secondary"
          className="text-right transparent-background"
        >
          {" "}
          {placeholder}{" "}
        </Dropdown.Toggle>{" "}
        <Dropdown.Menu>
          {" "}
          <Dropdown.Item onClick={handleMultiSelectClear} as="div">
            {" "}
            <Form.Check
              type="checkbox"
              label="Deselect All"
              checked={selectedItems.length === 0}
              onClick={handleMultiSelectClear}
              title="Deselect all options"
            />{" "}
          </Dropdown.Item>{" "}
          {options.map((option) => (
            <Dropdown.Item
            onClick={() => onProjectSelect(option.ProjectId.toString(), selectedItems.includes(option.ProjectId))}
            key={option.ProjectId} as="div">
              {" "}
              <Form.Check
                type="checkbox"
                label={option.ProjectName}
                value={option.ProjectId.toString()}
                checked={selectedItems.includes(option.ProjectId.toString())}
                onClick={() => onProjectSelect(option.ProjectId.toString(), selectedItems.includes(option.ProjectId))}
                title="Select this project for data filtering"
              />{" "}
            </Dropdown.Item>
          ))}{" "}
        </Dropdown.Menu>{" "}
      </Dropdown>
    </div>
  );
};

export default MultiSelectDropdown;
